import { XCircleIcon } from "@heroicons/react/20/solid";

export default function ErrorAlert({ text }: { text: string }) {
	return (
		<div className="jF-rounded-md jF-bg-red-50 jF-p-4 jF-mt-2">
			<div className="jF-flex">
				<div className="jF-flex-shrink-0">
					<XCircleIcon
						className="jF-h-5 w-5 jF-text-red-400"
						aria-hidden="true"
					/>
				</div>
				<div className="jF-ml-3">
					<h3 className="jF-text-sm jF-mt-0 jF-font-medium jF-text-red-800">
						{text}
					</h3>
				</div>
			</div>
		</div>
	);
}
